import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import AIBanner from './components/AIBanner';
import Portfolio from './components/Portfolio';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="dark bg-[#0a0a0a] min-h-screen">
      <Navbar />
      <Hero />
      <Services />
      <AIBanner />
      <Portfolio />
      <About />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
